<template>
  <div class="download-app">
    <!-- 确认进入下载页 -->
    <div class="download-in" v-if="backShow || weixinShow || backShowIOS">
      <!-- 微信钉钉引导图片 -->
      <img src="@/assets/lead.png" class="download-lead" alt v-if="weixinShow" />
      <img src="@/assets/download_01.png" alt />
      <!-- 安卓下载地址图片事件 -->
      <div class="imgDownload" @click="onDownload('android')" v-if="backShow">
        <img src="@/assets/download_02.png" alt />
      </div>
      <!-- IOs跳转APPstore图片地址事件 -->
      <div class="imgDownload" @click="onDownload('ios')" v-if="backShowIOS">
        <img src="@/assets/download_02.png" alt />
      </div>
      <!-- 微信钉钉点击提示图片事件 -->
      <div class="imgDownload" @click="onPrompt" v-if="weixinShow">
        <img src="@/assets/download_02.png" alt />
      </div>
      <img src="@/assets/download_03.png" alt />
    </div>
    <van-loading v-if="loading" />
  </div>
</template>

<script>
import { getDownloadList } from '@/api/newHome'
import { getNativeLocation } from '@/utils/getLocation'
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      backShow: false, //浏览器show
      backShowIOS: false, //浏览器show
      weixinShow: false, //微信show
      downloadType: '', //home(首页轮播),robot(机器人优惠券),business(市场洞察),purchase(机器人采购),brand(御元集)
      downloadList: {}, //loadUrl(首页轮播和优惠券唤醒APP跳转地址),appDownloadUrl(首页轮播下载APP地址),smartRobotUrl(机器人优惠券下载APP地址),marketInsDownloadUrl(市场洞察下载APP地址),smartRobotDownloadUrl(采购建议和御元集下载APP地址)
      downloadUrl: '',
      loading: false
    }
  },
  mounted() {
    this.downloadType = this.$route.query.type || ''
    let userAgent = navigator.userAgent
    let uaIswx = userAgent.toLowerCase()
    //判断是否在微信或钉钉内部打开
    let isMicDing = uaIswx.match(/MicroMessenger/i) == 'micromessenger' || uaIswx.match(/dingtalk/i) == 'dingtalk'
    if (isMicDing) {
      this.weixinShow = true
      return
    }
    this.getDownloadList()
  },
  methods: {
    evokeApp() {
      let userAgent = navigator.userAgent
      let isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端;
      if (isiOS) {
        this.backShowIOS = true
        this.goAPP()
      } else {
        Dialog.confirm({
          message: '在“智慧脸”中打开链接吗？',
          confirmButtonText: '打开'
        }).then(() => {
          this.goAPP()
        })
        this.backShow = true
      }
    },
    goAPP() {
      if (this.downloadType === 'business' || this.downloadType === 'purchase') {
        window.location.href = 'llsaas://ll.saas.com/source?' + this.downloadUrl
      } else if (this.downloadType) {
        window.location.href = 'llsaas://ll.saas.com/source?' + this.getBaseUrl(this.downloadList.loadUrl) //schema链接或者
      } else {
        window.location.href = 'llsaas://ll.saas.com/source'
      }
    },
    onDownload(type) {
      if (this.downloadType == 'robot') {
        window.location.href = this.downloadList.smartRobotUrl[type]
      } else if (this.downloadType == 'business') {
        window.location.href = this.downloadList.marketInsDownloadUrl[type]
      } else if (this.downloadType === 'purchase' || this.downloadType === 'brand') {
        window.location.href = this.downloadList.smartRobotDownloadUrl[type]
        // window.location.href = 'https://downloads.ybm100.com/saas/apk/saas-XZRobitSuggest-4.2.0.8.apk'
      } else {
        window.location.href = this.downloadList.appDownloadUrl[type]
      }
    },
    onPrompt() {
      Toast('请去浏览器打开链接')
    },
    getDownloadList() {
      this.loading = true
      let downloadId = ''
      if (this.downloadType === 'home' || this.downloadType === 'robot' || this.downloadType === 'business' || this.downloadType === 'purchase') {
        downloadId = ''
      } else {
        downloadId = this.downloadType
      }
      getDownloadList({ id: downloadId })
        .then(res => {
          this.loading = false
          if (res.data.code === 0) {
            this.downloadList = res.data.result || {}
            this.getNewUrl()
            this.evokeApp()
          } else {
            this.$message(res.data.msg)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message(err)
        })
    },
    getNewUrl() {
      if (this.$route.fullPath.indexOf('searchUrl=') === -1) {
        return
      }
      // if(this.$route.fullPath.indexOf('searchUrl=')!==-1){
      let searchUrl = this.$route.fullPath.substring(this.$route.fullPath.indexOf('searchUrl=')) //找到searchUrl后面的地址
      searchUrl = searchUrl.replace('searchUrl=', '') //字符串去除searchUrl=
      // 先将url解码
      searchUrl = decodeURIComponent(searchUrl)
      // 再将url中*替换回#
      searchUrl = searchUrl.replace(/\*/g, '#')
      // 市场洞察和商品采购建议跳转添加环境变量
      if (this.downloadType === 'business' || this.downloadType === 'purchase') {
        searchUrl = getNativeLocation(searchUrl)
        // alert(searchUrl)
      }
      // 再将url汉字转码
      searchUrl = encodeURI(searchUrl)
      //增加渠道参数
      if (this.downloadType === 'purchase') {
        //增加小智机器人渠道参数
        searchUrl = searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') + 'channel=robotWeb'
      } else if (this.downloadType === 'brand') {
        //增加御元集渠道参数
        searchUrl = searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') + 'channel=brandWeb'
      } else if (this.downloadType === 'business') {
        //增加市场洞察渠道参数
        searchUrl = searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') + 'channel=businessWeb'
      }
      // alert(searchUrl)
      console.log(searchUrl)
      // 最后再把urlbase64转码
      const Base64 = require('js-base64').Base64
      const exStr = Base64.encode(searchUrl)
      this.downloadUrl = exStr
      // }
    },
    getBaseUrl(url) {
      const Base64 = require('js-base64').Base64 //base64引入，解码
      let decodeUrl = Base64.decode(url) //先把链接base64解码
      decodeUrl = decodeUrl + (decodeUrl.indexOf('?') > -1 ? '&' : '?') + 'channel=robotWeb' //拼接渠道参数
      // 最后再把urlbase64转码
      // alert(decodeUrl)
      const exStr = Base64.encode(decodeUrl)
      return exStr
    }
  }
}
</script>

<style lang="less" scoped>
.download-app {
  width: 100%;
  background-color: #408afd;
  height: 100%;
  overflow-y: auto;
  position: absolute;
  /deep/ .van-loading {
    text-align: center;
    top: -45%;
  }
  .download-in {
    position: relative;
    img {
      width: 100%;
    }
    .imgDownload {
      margin: 0;
      padding: 0;
    }
    .download-lead {
      position: absolute;
      top: 5px;
      left: 4%;
      width: 95%;
    }
  }
}
</style>
